import {setURLParams} from 'BenchlingUtil';
import {FormActionConfigInput, FormDefinitionContent} from 'forms/form-designer/Constants';
import EntityStore from 'stores/EntityStore';
import * as net from 'util/Net';

export function createForm(
  formName: string,
  templateCollectionId: string,
  definition: FormDefinitionContent,
  actionConfigs: Array<FormActionConfigInput>,
  schemaId?: string
): Promise<{formDefinitionId: string}> {
  return net.postJSONPromise({
    url: '/1/api/forms/form-definitions',
    data: {
      name: formName,
      templateCollectionId,
      schemaId,
      definition,
      actionConfigs,
    },
  });
}

export function renameForm(formDefinitionId: string, name: string): Promise<{formDefinitionId: string}> {
  return net.patchJSONPromise({
    url: `/1/api/forms/form-definitions/${formDefinitionId}`,
    data: {
      name,
    },
  });
}

export function updateFormTemplateCollection(
  formDefinitionId: string,
  templateCollectionId: string
): Promise<{formDefinitionId: string}> {
  return net.postJSONPromise({
    url: `/1/api/forms/form-definitions/${formDefinitionId}/move`,
    data: {
      templateCollectionId,
    },
  });
}

export function updateFormDefinition(
  formDefinitionId: string,
  definition: FormDefinitionContent,
  actionConfigs: Array<FormActionConfigInput>
): Promise<{formDefinitionId: string}> {
  return net.postJSONPromise({
    url: `/1/api/forms/form-definitions/${formDefinitionId}/form-definition-versions`,
    data: {
      definition,
      actionConfigs,
    },
  });
}

export function formDefinitionUrl(formDefinitionId: string): string {
  return `/${EntityStore.currentUser().url_identifier}/forms/${formDefinitionId}`;
}

export function formCreatorUrl(name?: string, templateCollection?: string, taskSchemaId?: string): string {
  return setURLParams(`/${EntityStore.currentUser().url_identifier}/forms/create`, {
    name,
    templateCollection,
    taskSchemaId,
  });
}
